import React from "react";
import { Box, Stack, Container, Skeleton } from "@mui/material";

const skeletonProjects = [
  {
    id: 1,
    gridColumn: { xs: "span 12", lg: "span 8" },
    gridRow: { xs: "span 1", lg: "span 2" },
  },
  {
    id: 2,
    gridColumn: { xs: "span 12", lg: "span 4" },
    gridRow: { xs: "span 1", lg: "span 1" },
  },
  {
    id: 3,
    gridColumn: { xs: "span 12", lg: "span 4" },
    gridRow: { xs: "span 1", lg: "span 1" },
  },
  {
    id: 4,
    gridColumn: { xs: "span 12", lg: "span 12" },
    gridRow: { xs: "span 1", lg: "span 1" },
  },
];

export default function TopProjectsSkeleton() {
  return (
    <Box>
      <Container
        maxWidth="exl"
        sx={{
          py: { xs: 8, lg: 15 },
          "& *": {
            direction: "rtl",
          },
        }}
      >
        {/* Header Skeleton */}
        <Stack
          justifyContent="center"
          alignItems="center"
          mb={{ xs: 5, lg: 8 }}
          spacing={2}
        >
          <Skeleton
            variant="rounded"
            width={250}
            height={50}
            animation="wave"
            sx={{ bgcolor: "rgba(255,255,255,0.08)" }}
          />
          <Stack spacing={1} alignItems="center" sx={{ width: "100%" }}>
            <Skeleton
              variant="text"
              width={{ xs: "90%", lg: "40%" }}
              height={20}
              animation="wave"
              sx={{ bgcolor: "rgba(255,255,255,0.08)" }}
            />
            <Skeleton
              variant="text"
              width={{ xs: "70%", lg: "30%" }}
              height={20}
              animation="wave"
              sx={{ bgcolor: "rgba(255,255,255,0.08)" }}
            />
          </Stack>
        </Stack>

        {/* Grid Skeleton */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(12, 1fr)",
            gridAutoRows: { xs: "250px", lg: "300px" },
            gap: { xs: 2, lg: 3 },
          }}
        >
          {skeletonProjects.map((project) => (
            <Box
              key={project.id}
              sx={{
                gridColumn: project.gridColumn,
                gridRow: project.gridRow,
                position: "relative",
                borderRadius: "24px",
                overflow: "hidden",
                bgcolor: "rgba(255,255,255,0.03)", // پس‌زمینه تیره و محو کارت
              }}
            >
              {/* اسکلتون اصلی کارت (به جای عکس بک‌گراند) */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
                sx={{ bgcolor: "rgba(255,255,255,0.05)" }}
              />

              {/* المان‌های داخلی کارت (آیکون و متن‌ها) */}
              <Stack
                justifyContent="space-between"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  p: { xs: 3, lg: 4 },
                  boxSizing: "border-box",
                }}
              >
                {/* اسکلتون دکمه آیکون */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                    animation="wave"
                    sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
                  />
                </Box>

                {/* اسکلتون دسته بندی و عنوان */}
                <Box>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                    animation="wave"
                    sx={{ mb: 1, bgcolor: "rgba(255,255,255,0.1)" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={180}
                    height={30}
                    animation="wave"
                    sx={{ bgcolor: "rgba(255,255,255,0.1)" }}
                  />
                </Box>
              </Stack>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}